import React from "react";
import { motion } from "framer-motion";
import "./Career.css";

const Career = () => {
  const benefits = [
    {
      icon: "🌟",
      title: "Innovate with Purpose",
      description: "Work on meaningful projects that make a difference",
    },
    {
      icon: "🌍",
      title: "Remote-Friendly Culture",
      description: "Flexible work arrangements that fit your lifestyle",
    },
    {
      icon: "🚀",
      title: "Career Growth",
      description: "Continuous learning and advancement opportunities",
    },
    {
      icon: "❤️",
      title: "Mission-Driven Team",
      description: "Join passionate people changing the wellness industry",
    },
    {
      icon: "👥",
      title: "Collaborative Environment",
      description: "Work with talented individuals from diverse backgrounds",
    },
    {
      icon: "🏆",
      title: "Recognition & Rewards",
      description: "Your contributions are valued and celebrated",
    }
  ];

  const handleLinkedInClick = () => {
    window.open(
      "https://www.linkedin.com/company/pranayuv-technologies/posts/?feedView=all",
      "_blank"
    );
  };

  const handleExploreOpportunities = () => {
    window.open(
      "https://www.linkedin.com/company/pranayuv-technologies/jobs",
      "_blank"
    );
  };

  const handleSendResume = () => {
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSedrLy4Ah9kKrw3GWMJCVg9buR3SC-K-q95ew_sEMgKbgiw_w/viewform",
      "_blank"
    );
  };

  return (
    <div className="careers-container">
      {/* Animated Background Elements */}
      <div className="careers-background-design">
        <div className="careers-shape careers-shape-1"></div>
        <div className="careers-shape careers-shape-2"></div>
        <div className="careers-shape careers-shape-3"></div>
      </div>

      <div className="careers-grid-container">
        {/* Hero Section */}
        <motion.section
          className="careers-hero-section"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="careers-hero-overlay"></div>
          <div className="careers-hero-background"></div>
          <div className="careers-hero-gradient"></div>

          <motion.div
            className="careers-hero-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="careers-hero-icon">
              <svg
                className="careers-heart-icon"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
              </svg>
            </div>
            <h1 className="careers-hero-title">Join Pranayuv</h1>
            <p className="careers-hero-subtitle">
              We're shaping the future of wellness. Be part of something
              meaningful and help millions live healthier lives.
            </p>

            <div className="careers-feature-icons">
              <div className="careers-feature-item">
                <div className="careers-feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
                  </svg>
                </div>
                <span>Innovative</span>
              </div>
              <div className="careers-feature-item">
                <div className="careers-feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                </div>
                <span>Collaborative</span>
              </div>
              <div className="careers-feature-item">
                <div className="careers-feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                  </svg>
                </div>
                <span>Caring</span>
              </div>
            </div>
          </motion.div>
        </motion.section>

        {/* Content Section */}
        <motion.section
          className="careers-content-section"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="careers-content-container">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="careers-content-wrapper"
            >
              <div className="careers-content-header">
                <h2 className="careers-content-title">Career Opportunities</h2>
                <p className="careers-content-subtitle">
                  Discover amazing opportunities to grow with us
                </p>
              </div>

              <div className="careers-action-buttons">
                <button
                  className="careers-primary-btn"
                  onClick={handleExploreOpportunities}
                >
                  Explore Opportunities →
                </button>
                <button
                  onClick={handleLinkedInClick}
                  className="careers-secondary-btn"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      x="2"
                      y="9"
                      width="4"
                      height="12"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle
                      cx="4"
                      cy="4"
                      r="2"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Follow on LinkedIn
                </button>
              </div>

              {/* Benefits Section */}
              <div className="careers-benefits-section">
                <h3 className="careers-benefits-title">Why Work With Us?</h3>
                <div className="careers-benefits-grid">
                  {benefits.map((benefit, index) => (
                    <motion.div
                      key={index}
                      className="careers-benefit-card"
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6, delay: 0.1 * index }}
                    >
                      <div className="careers-benefit-icon">
                        <span className="careers-emoji">{benefit.icon}</span>
                      </div>
                      <h4 className="careers-benefit-title">{benefit.title}</h4>
                      <p className="careers-benefit-description">{benefit.description}</p>
                    </motion.div>
                  ))}
                </div>
              </div>

              {/* Apply Section */}
              <div className="careers-apply-section">
                <h3 className="careers-apply-title">Don't See Your Role?</h3>
                <p className="careers-apply-text">
                  We're always looking for talented individuals who share our passion
                  for wellness and innovation.
                </p>
                
                <div className="careers-apply-actions">
                  <button className="careers-resume-btn" onClick={handleSendResume}>
                    📧 Send Your Resume
                  </button>
                  
                  <div className="careers-email-info">
                    <p className="careers-email-note">or email us directly at</p>
                    <span className="careers-email-address">
                      careers@pranayuv.com
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.section>
      </div>
    </div>
  );
};

export default Career;